import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class MailchimpIndexRoute extends Route {
  @service fundsService;
  @service router;

  redirect() {
    let { mailchimpSetting } = this.modelFor('funds.fund.more.mailchimp');
    if (mailchimpSetting) {
      if (mailchimpSetting.fundSettings.length > 0) {
        if (
          mailchimpSetting.fundSettings.firstObject.fundId ===
          this.fundsService.selectedFund.id
        ) {
          this.router.transitionTo(
            'funds.fund.more.mailchimp.connected-to-fund',
          );
        } else {
          this.router.transitionTo(
            'funds.fund.more.mailchimp.connected-to-another-fund',
          );
        }
      } else {
        this.router.transitionTo('funds.fund.more.mailchimp.connected');
      }
    } else {
      this.router.transitionTo('funds.fund.more.mailchimp.not-connected');
    }
  }
}
